<template>
  <el-row class="Login">
    <el-col :span="24" class="Login-content">
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </el-col>
    <el-col :span="24" class="Login-foot">
      <div class="foot-floor1">
        {{ HomeInfo.obj.footObj.copyright }}
      </div>
      <div class="foot-floor1">
        地址：{{ HomeInfo.obj.footObj.address }}
      </div>
    </el-col>
  </el-row>
</template>

<script>
import mock from '@/utils/mock'
export default {
  components: {},
  data() {
    return {
      HomeInfo: mock.home.Home.viewInfo
    }
  },
  computed: {},
  mounted() {},
  methods: {
    control(type, condition) {
      return mock.system.global.control[type](condition)
    }
  }
}
</script>

<style scoped lang="scss">
.Login {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  position: relative;
  &-content{
    width: 100%;
    height: 100%;
    min-width: $xr-min-width;
  }
  &-foot {
    position: absolute;
    bottom: 15px;
    right: 0;
    height: 60px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    > div {
      flex: 1;
      @include fun-design(6);
    }
    .foot-floor1{
      background: rgba(0,0,0,0);
      font-size: 14px;
      line-height: 30px;
      color: #fff;
      font-family: "Adobe Heiti Std";
      text-align: center;
    }
  }
}
</style>
